// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content_Sb2LG relative text-[0.925rem]"};